import {Component, Inject, Input, OnInit, Optional, ViewChild, Output, EventEmitter} from '@angular/core';
import {NG_ASYNC_VALIDATORS, NG_VALIDATORS, NG_VALUE_ACCESSOR, NgModel} from '@angular/forms';
import {ElementBase} from '../../class';
import {catchError, debounceTime, distinctUntilChanged, switchMap} from 'rxjs/operators';
import {of} from 'rxjs/observable/of';
import {AutoCompleteService} from '../../services/auto-complete.service';
import {Observable} from 'rxjs/Observable';

@Component({
  selector: 'app-autocomplete',
  templateUrl: './autocomplete.component.html',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: AutocompleteComponent,
    multi: true,
  }],
})
export class AutocompleteComponent extends ElementBase<any> implements OnInit {
  @ViewChild(NgModel) model: NgModel;
  public identifier = `frm-auto-${identifier++}`;
  @Input() public bindLabel: string;
  @Input() public placeholder: string;
  @Input() public disabled: boolean;
  @Input() public type: string;

  constructor(
    private _autoCompleteService: AutoCompleteService,
    @Optional() @Inject(NG_VALIDATORS) validators: Array<any>,
    @Optional() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: Array<any>,
  ) {
    super(validators, asyncValidators);
  }

  ngOnInit() {

  }

  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(term =>
        this._autoCompleteService.find(this.type, term).pipe(
          catchError(() => {
            return of([]);
          }))
      )
    );

  formatter = (dto: any) => this.bindLabel ? dto[this.bindLabel] : dto;
}

let identifier = 0;



// WEBPACK FOOTER //
// ./src/app/modules/forms/components/autocomplete/autocomplete.component.ts